export default __webpack_public_path__ + "static/media/iteratecLogo.32df151d.png";